module.exports = __webpack_public_path__ + "static/img/liucheng3.b7bef749.png";